/**
 * * *  * *******************************************************************************************************
 *
 * * V2.0
 *
 * User: danielr
 * Date: 14/01/14
 *
 * refactor of the whole positioning system. it now calls the PositionUtils.position() method
 * permutation positioning have been removed. instead, the two new parameters have been added to the options:
 * - position: Optional - DropdownMenu.POSITION of the list items - default: DropdownMenu.POSITION.BOTTOM
 * - align: Optional - DropdownMenu.ALIGN of the list items - default: DropdownMenu.ALIGN.MIDDLE
 *
 * added icon support in list:
 * the model has a new property called icon which is the class of the icon to be added
 *
 *
 * ********************************************************************************************************
 *
 * V1.1
 *
 * User: margalitb
 * Date: 10/06/13
 * Visual PDF: https://docs.google.com/a/liveperson.com/file/d/0B7O_LAPhjkbkLUZpZnRnUU9hWms/edit
 *
 * This widget is used to implement a dropdown-menu component on the page.
 *
 * Options:
 * el - mandatory. jQuery element. The element on the page where the component will be created.
 * name - mandatory. The text of the dropdown-menu button.
 * vent - mandatory. Get the event of the dropdown-menu selection. event name: "change:selection".
 * collection - mandatory. of type: DropdownMenu.Collection. this collection present the list in the menu.
 * enable  - optional. Defined the dropdown-menu state - enable or disable. (Enabled by default). Optional values:  true / false.
 * tabindex  -  optional. Attribute tabindex for the dropdown-menu element.
 * permutation - optional. Changes the dropdown-menu alignment. existing permutations:    DropdownMenu.PERMUTATION.A (center) , DropdownMenu.PERMUTATION.B (right) , DropdownMenu.PERMUTATION.C (left).
 * nowrap - optional. define whether to break line in the list for text or not.
 *
 * Using Example:
 *
 * template:
 * <div class="dropdown-menu-container"></button>
 *
 *  js:
 *  var Media = require("media");
 *
 *  var optionsItems = new   DropdownMenu.Collection([
 *  {  id: 0,   "actionName" : "Delete"  ,  "enabled": true  },
 *  {  id: 1,  "actionName": "Create","enabled": false },
 *  { id: 2,  "actionName" : "Update"  , "enabled": true },]);
 *
 * var vent = Media.vent();
 *
 *  var campaignDropdown = new DropdownMenu({
 *      name: 'Actions' ,
 *      el:elParent,
 *      collection: optionsItems,
 *      permutation: DropdownMenu.PERMUTATION.C,
 *      tabindex: '1000' ,
 *      vent:vent
 *  });
 *  campaignDropdown.render();
 *
 *  vent.on('change:selection',  function(id){ alert('selected' + id);});
 *
 *
 * *******************************************************************************************************
 *
 */
define(function (require) {
    "use strict";

    var $ = require('jquery');
    var _ = require("underscore");
    var Logger = require('logger');
    var Marionette = require('marionette');
    var template = require('ui/dropdown-menu/templates/dropdownMenu.tmpl');
    var DropdownMenuItemView = require('ui/dropdown-menu/js/views/DropdownMenuItemView');
    var DropdownMenuCollection = require('ui/dropdown-menu/js/collections/DropdownMenuCollection');
    var DropdownMenuModel = require('ui/dropdown-menu/js/models/DropdownMenuModel');
    var PositionUtils = require('ui/PositionUtils');

    require('ui.plugins/jquery.ba-outside-events');

    var DropdownMenu = Marionette.CompositeView.extend({
        version: "2.0",
        template : template,
        itemView : DropdownMenuItemView,
        itemViewContainer : ".items",

        ui : {
            wrapper : ".dropdown-menu-wrapper",
            ddButton : ".dropdown-menu-wrapper .dropdown-btn",
            ul : '.dropdown-menu-wrapper ul'
        },

        events : {
            "click .dropdown-menu-wrapper .dropdown-btn" : "onDropdownButtonClick",
            "keydown .dropdown-menu-wrapper" : "handleButtonKeyPress",
            "clickoutside":"outsideClicked"
        },

        initialize : function (options) {
            this.menuMinWidth = null;

            this.logger = Logger.getLogger("DropdownMenuWidget");
            this.validateMandatory(options);

            this.enable = _.isUndefined(options.enable) ? true : options.enable;
            this.permutation = options.permutation || DropdownMenu.PERMUTATION.A;
            this.left = null;
            this.tabindex = options.tabindex;
            this.vent = options.vent;
            this.position = options.position;
            this.align = options.align;
            this.buttonPermutation = options.buttonPermutation || DropdownMenu.BUTTON_PERMUTATION.DEFAULT;
            this.nowrap = options.nowrap;
            this.positionMap = {};
            this.positionMap[DropdownMenu.POSITION.TOP] = PositionUtils.PositionEntity.POSITION.TOP;
            this.positionMap[DropdownMenu.POSITION.BOTTOM] = PositionUtils.PositionEntity.POSITION.BOTTOM;
            this.alignMap = {};
            this.alignMap[DropdownMenu.ALIGN.LEFT] = PositionUtils.PositionEntity.ALIGN.LEFT;
            this.alignMap[DropdownMenu.ALIGN.RIGHT] = PositionUtils.PositionEntity.ALIGN.RIGHT;
            this.alignMap[DropdownMenu.ALIGN.MIDDLE] = PositionUtils.PositionEntity.ALIGN.MIDDLE;

            // Create inner model for template.
            this.model = new DropdownMenuModel({
                name : options.name,
                permutation: this.buttonPermutation,
                items : options.collection
            });
            this.collection = this.model.get("items");
        },

        validateMandatory: function(options){

            if (!options.collection) {
                this.logger.error("Collection collection in Dropdown-Menu  widget is mandatory");
                this.logger.graph({ name: "UIComponents:DropdownMenu:missingCollection"});

                return null;
            }

            if (!options.el) {
                this.logger.error("Element in Dropdown-Menu  widget is mandatory");
                this.logger.graph({ name: "UIComponents:DropdownMenu:missingEl"});
                return null;
            }
        },

        /**
         * Add some attributes after the dropdown-menu HTML element rendered.
         */
        onRender : function () {
            var that = this;

            if (_.isEmpty(this.model.get("name"))) {
                this.ui.ddButton.addClass("no-text");
            }

            // If required, initialize the dropdown-menu element disabled.
            if (that.enable === false) {
                that.ui.ddButton.addClass("disabled");
            }

            if (that.nowrap) {
                that.ui.ul.addClass("dd-nowrap");
            }

            this.ui.ddButton.attr("tabindex", that.tabindex);
            this.ui.wrapper.addClass(this.permutation);

            if(_.isEmpty(this.model.get("name"))){
                this.ui.ddButton.addClass("dropdown-with-no-text");
            }

            // On dropdown-menu hover: remove the active class that indicated instead of hover.
            that.ui.ul.hover(function () {
                that.ui.ul.find(".active").removeClass("active");
            });

            this.listenTo(this, "itemview:changeSelection", function (item) {
                if(item.model.get("enabled") === true){
                    that.closeDropdown();
                    if(!_.isUndefined(that.vent)) {
                         that.vent.trigger("change:selection", item.model.id);
                    }
                    that.trigger(DropdownMenu.TRIGGERING.CHANGE, item.model.id);
                }
            });
        },

        /**
         * triggered when the view is close
         */
        onClose : function () {
            // Custom cleanup or closing code
            if (this.ui.wrapper) {
                this.ui.wrapper.empty();
                this.ui.wrapper.remove();
            }
        },

        /**
         * set the state of the dropdown menu button actions to enabled/disabled
         * @param {true / false} For dropdown-menu enable - true, otherwise - false.
         */
        setEnabled : function (enable) {
            this.enable = typeof enable === "undefined" ? true : enable;
            this.ui.ddButton.toggleClass("disabled",this.enable === false );
        },

        /**
         * Set the items from outside.
         * @param items - collection of items. should be instance of DropdownMenu.Collection
         */
        setItems:function (items) {
            if(items instanceof DropdownMenu.Collection) {
                this.model.set("items", items);
                this.collection.reset(items.models);
            }
            else{
                this.logger.error("items not of type DropdownMenu.Collection" ,"Dropdown:setItems");
                this.logger.graph({ name: "UIComponents:DropdownMenu:setItems:ItemsTypeIncorrect"});
            }
        },

        /**
         * @return {true / false} -  For dropdown-menu. enabled - true, otherwise - false.
         */
        getEnabled : function () {
            return this.enable;
        },

        /**
         *  Close dropdown-menu when clicking everywhere outside of the dropdown-menu.
         */
        outsideClicked : function () {
            this.closeDropdown();
        },

        /**
         *  Open dropdown-menu when clicking on the menu's button.
         */
        openDropdown : function () {
            if (!this.ui.ddButton.hasClass("disabled")) {
                this.ui.ul.show(); // Show the dropdown-menu
                this.initPositioning();

                //align the drop down menu with the width of the button above it
                this._calculateMenuWidth();
                this._setMenuWidth();
                this.setDropdownPosition();
            }
        },

        //calculate the minimum width for the drop down menu, according to the button size above it
        //if the width has already been calculated, return without doing anything
        _calculateMenuWidth :function() {
            if (_.isNull(this.menuMinWidth)) {
                var dropDownListTotalPadding = this._getTotalPaddingBorderDropdownList();
                this.menuMinWidth = this.ui.ddButton.outerWidth() - dropDownListTotalPadding;
            }
        },

        //set a "min-width" for the dropdown menu. notice that the "px" is hardcoded here
        _setMenuWidth : function() {
            this.ui.ul.css("min-width", this.menuMinWidth+"px");
        },

        //helper function for the padding calculation in _getPaddingOfMenuButton.
        //returns the numeric data in the css element received, and returns 0 if it's not found
        _extractCSSDataList: function(nameOfCSSElement) {
            var cssDataArray = this.ui.ul.css(nameOfCSSElement).match(/\d*/);
            var cssDataString = (!_.isNull(cssDataArray) && cssDataArray.length > 0) ? cssDataArray[0] : 0;
            return parseInt(cssDataString,10);
        },

        //calculates the sum of paddings and borders to the sides of the menu button
        _getTotalPaddingBorderDropdownList : function(){
            var marginRight = this._extractCSSDataList("padding-right");
            var marginLeft = this._extractCSSDataList("padding-left");
            var borderRight = this._extractCSSDataList("border-right-width");
            var borderLeft = this._extractCSSDataList("border-left-width");
            return (marginRight + marginLeft + borderRight + borderLeft);
        },

        initPositioning: function(){
            if (_.isUndefined(this.position)){
                this.position = DropdownMenu.POSITION.BOTTOM;
            }
            if (_.isUndefined(this.align)){
                this.align = DropdownMenu.ALIGN.MIDDLE;
            }
        },

        /**
         *  Hide dropdown-menu..
         */
        closeDropdown : function () {
            this.ui.ul.hide();
        },

        onPositionCalculated: function(pos){
            if (pos.isValid){
                this.ui.ul.addClass(pos.cls);
                this.ui.ul.css({"top": pos.top, "left": pos.left});
            }
            else {
                this.logger.error(pos.err);
                this.logger.graph({ name: "UIComponents:DropdownMenu:onPositionCalculated:posErr"});
            }
        },

        /**
         *  Set the arrow permutation of the dropdown-menu. (Center / Right / Left).
         */
        setDropdownPosition : function () {
            PositionUtils.position({
                targetEl: this.ui.ddButton,
                floatingEl: this.ui.ul,
                position: this.positionMap[this.position],
                align: this.alignMap[this.align]
            }, _.bind(this.onPositionCalculated, this));
        },

        /**
         *  Open dropdown-menu.
         */
        onDropdownButtonClick : function (event) {
            var that = this;
            // Open the dropdown-menu only if its enabled.
            if (that.enable) {
                // Open the dropdown-menu only if its not visible.
                if (that.ui.ul.is(":hidden")) {
                    that.openDropdown(); // Open the dropdown-menu
                    that.ui.ul.find("li").removeClass(DropdownMenu.ACTIVE_CLASS); // Remove any existing active class.
                    that.setFirstItemActive(); // Set active class to the first li.
                }
            }
        },

        /**
         * returns the item currently in focus when navigating with the keyboard.
         *
         * @param view the view's instance
         * @returns element
         */
        getActiveItem : function (view) {
            return this.$el.find(".items ." + DropdownMenu.ACTIVE_CLASS);
        },

        /**
         * marks an item from the items list as active and remove the mark from the previous active item.
         *
         * @param oldItem the item to remove the active mark from.
         * @param newItem the item to mark as active.
         */
        setActive : function (oldItem, newItem) {
            oldItem.removeClass(DropdownMenu.ACTIVE_CLASS);
            newItem.addClass(DropdownMenu.ACTIVE_CLASS);
        },

        /**
         * handles keyboard navigation.
         *
         * @param view the view's instance
         * @param key the value of the key that was presses.
         */
        handleButtonKeyPress : function (key) {
            var view = this;
            var pos, scroll;
            var menu = $(view.ui.menu);
            var activeItem = this.getActiveItem(view);
            if(activeItem.length < 1){
                activeItem  = this.setFirstItemActive();
            }

            var that = this;

            switch (key) {
                // Esc closes the items list.
                case KeyCode.ESC:
                    that.closeDropdown();
                    break;

                // down arrow opens the items list if it's closed or otherwise navigates down the list until it reaches the
                // bottom most item. navigated items are made active.
                case KeyCode.ARROW_DOWN:
                    if (that.ui.ul.is(":hidden")) {
                        if (that.ui.ddButton.is(":focus")) {
                            that.openDropdown();
                            that.ui.ul.find("li").removeClass(DropdownMenu.ACTIVE_CLASS);
                            that.setFirstItemActive();
                        } else {
                            that.closeDropdown();
                        }
                    } else {
                        var next = activeItem.next();
                        // Skip disabled items.
                        while (next.length > 0 && next.hasClass("disabled")) {
                            next = next.next();
                        }

                        if (next.length > 0) {
                            that.setActive(activeItem, next);
                        }
                    }
                    break;

                // up arrow navigates up the list until it reaches the top most item and then it closes the list.
                case KeyCode.ARROW_UP:
                    if (!that.ui.ul.is(":hidden")) {
                        var prev = activeItem.prev();
                        // Skip disabled items.
                        while (prev.length > 0 && prev.hasClass("disabled")) {
                            prev = prev.prev();
                        }

                        if (prev.length > 0) {
                            that.setActive(activeItem, prev);
                        }
                    }
                    break;

                // selects the active item.
                case KeyCode.ENTER:  // enter

                    if (!that.ui.ul.is(":hidden")) {
                        $(activeItem).click();
                    }
                    that.onDropdownButtonClick();
            }
        }, // EO handleButtonKeyPress(..)

        setFirstItemActive: function(){
            return  this.ui.ul.find(">:first-child").addClass(DropdownMenu.ACTIVE_CLASS); // Set active class to the first li.
        },

        /**
         *  Calculate an element width - width + padding + border.
         */
        getElementTotalWidth : function (elem) {
            var totalWidth = elem.width();
            totalWidth += this.getPaddingAndBorderWidth(elem);
            return totalWidth;
        },

        getPaddingAndBorderWidth : function(elem){
            var totalWidth = parseInt(elem.css("padding-left"), 10) + parseInt(elem.css("padding-right"), 10); //Total Padding Width
            totalWidth += parseInt(elem.css("borderLeftWidth"), 10) + parseInt(elem.css("borderRightWidth"), 10); //Total Border Width
            return totalWidth;
        }
    });

    /**
     * represents the keyboard key-codes that are handled by the dropdown.
     *
     * @type {object}
     */
    var KeyCode = {
        ESC : 27,
        ENTER : 13,
        ARROW_UP : 38,
        ARROW_DOWN : 40
    };

    /**
     * Public static eNum of the optional permutation
     */
    DropdownMenu.PERMUTATION = {
        A : "perm-A",
        B : "perm-B",
        C : "perm-C",
        D : "perm-D" // inline permutation
    };

    DropdownMenu.TRIGGERING = {
        CHANGE:"change"
    };

    DropdownMenu.POSITION = {
        TOP: 1,
        BOTTOM: 3
    };

    DropdownMenu.ALIGN = {
        MIDDLE: 1,
        LEFT: 2,
        RIGHT: 3
    };

    DropdownMenu.BUTTON_PERMUTATION = {
        DEFAULT:"default",
        PLUS:"special",
        MEDIUM: "medium"
    };

    DropdownMenu.Collection = DropdownMenuCollection;
    DropdownMenu.ACTIVE_CLASS = "active";

    return DropdownMenu;
});
